import { render, staticRenderFns } from "./OverviewSupport.vue?vue&type=template&id=20f678ea"
import script from "./OverviewSupport.vue?vue&type=script&lang=js"
export * from "./OverviewSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports